import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, input, Output, signal } from '@angular/core';
import { GALAXY_UPLOADER_SERVICE_TOKEN, GalaxyUploaderModule } from '@vendasta/galaxy/uploader';
import { ImageUploadService } from './image-upload.service';
import { MatButtonModule } from '@angular/material/button';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { ImageUploadModalComponent } from './image-upload-modal/image-upload-modal.component';

@Component({
  selector: 'ai-image-upload',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyUploaderModule,
    MatButtonModule,
    GalaxyAvatarModule,
    MatIconModule,
    MatMenuModule,
  ],
  providers: [{ provide: GALAXY_UPLOADER_SERVICE_TOKEN, useClass: ImageUploadService }],
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
})
export class ImageUploadComponent {
  imageUrl = input<string | null>();
  defaultSvg = input<string | null>();
  @Output() imageUrlChanged = new EventEmitter<string>();

  newUploadedImageUrl = signal<string | null>(null);
  private readonly dialog = inject(MatDialog);

  onChangeImage(): void {
    const dialogRef = this.dialog.open(ImageUploadModalComponent, {
      width: '500px',
      data: {
        imageURL: this.imageUrl(),
        defaultSvg: this.defaultSvg(),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.remove) {
          this.imageUrlChanged.emit('');
        } else {
          this.imageUrlChanged.emit(result.newImageUrl);
          this.newUploadedImageUrl.set(result.newImageUrl);
        }
      }
    });
  }
}
